<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <h1><i class="far fa-analytics m-r-sm"></i> Reports</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>



// WEBPACK FOOTER //
// IndexHeading.vue?3bf601a0